import React, { useMemo } from 'react';

import { SearchConfigure } from '@uncinc/react-searchkit';
import type { SearchParameters } from '@uncinc/react-searchkit/types';

import SearchTopical from '../SearchTopical';
import { requestOptions, runtimeMappings, sorting } from './config';

export interface SearchTopicalEventsProps {
  searchParameters: SearchParameters;
}

const SearchTopicalEvents: React.FC<SearchTopicalEventsProps> = ({ searchParameters }) => {
  return useMemo(() => (
    <SearchTopical
      requestOptions={requestOptions}
      searchSettings={{
        sorting,
        runtime_mappings: runtimeMappings,
      }}
    >
      <SearchConfigure {...searchParameters} />
      <SearchTopical.ResultsEvents />
    </SearchTopical>
  ), [searchParameters]);
};

export default SearchTopicalEvents;
